import { useState, useEffect, useRef, ReactNode } from 'react';
import moment, { Moment } from 'moment';
import 'moment-duration-format';
import { Text } from '@mantine/core';

interface CountdownProps {
  deadline: Moment;
  onFinish?: () => void;
  format?: string;
  children?: ReactNode;
}

const Countdown = (props: CountdownProps) => {
  const { deadline, format = 'HH:mm:ss', onFinish, children } = props;

  const intervalRef = useRef<any>();
  const [differenceInMS, setDifferenceInMS] = useState(0);

  useEffect(() => {
    setDifferenceInMS(deadline.diff(moment(), 'milliseconds'));
    clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      setDifferenceInMS((preValue) => {
        if (preValue <= 1000) {
          if (onFinish) onFinish();
          clearInterval(intervalRef.current);
          return 0;
        }

        return preValue - 1000;
      });
    }, 1000);

    return () => {};
  }, [deadline, onFinish]);

  const formattedDifference = moment.duration(differenceInMS, 'milliseconds').format(format, { trim: false });

  const isFinished = differenceInMS <= 0;
  const output = isFinished && children ? children : formattedDifference;

  return <Text>{output}</Text>;
};

export default Countdown;
